import { AudioFilled, CloseOutlined, LoadingOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Input, Rate, Space, Typography } from "antd"
import { useEffect, useRef, useState } from "react";
import { PURPLE } from "../../styles/styleUtils";
import { getAIHelp, submitFeedback } from "../../store/actions/CommonActions";
import botIcon from "../../assets/images/icon_robot.svg"
import SearchDocView from "./SearchDocView";
import TextArea from "antd/es/input/TextArea";
import UMCButton from "../common/UMCButton";
import { useSelector } from "react-redux";
import { formatDictString, getTranslated } from "../../utils/CommonUtils";


const SearchBot = () => {

    const [searchValue, setSearchValue] = useState()
    const [placeHolderVal, setPlaceHolderVal] = useState()
    const [disableMic, setDisableMic] = useState(false)
    const [loading, setLoading] = useState(false)
    const [expanded, setExpanded] = useState(false)
    const [helpData, setHelpData] = useState(null)
    const [rating, setRating] = useState()
    const [feedback, setFeedback] = useState("")
    const [fbSubmitted, setFBSubmitted] = useState(false)

    const dict = useSelector((state) => state.common.dict)

    const observedDiv = useRef(null);

    const userAgent = navigator.userAgent;
    const isFirefox = (userAgent.match(/firefox|fxios/i))

    useEffect(() => {
        setPlaceHolderVal(getTranslated(dict, "MSG_BOT_HELP"))
    }, [dict])


    const handleChange = (event) => {
        if (event?.target?.value) {
            setPlaceHolderVal(getTranslated(dict, "MSG_BOT_HELP"))
            setSearchValue(event.target.value)
        } else {
            setSearchValue("")
        }
    }

    const handleSend = () => {
        if (searchValue) {
            setPlaceHolderVal(getTranslated(dict, "MSG_BOT_HELP"))
            setLoading(true)

            getAIHelp(searchValue, (helpData) => {
                setExpanded(false)
                setHelpData(helpData)
                setFBSubmitted(false)
                setLoading(false)
            })
        }
    }

    const handleChatClose = () => {
        setHelpData(null)
        setFeedback("")
        setRating("")
    }

    const runSpeechRecog = () => {
        let recognization = window.webkitSpeechRecognition || window.SpeechRecognition;
        recognization = new recognization()
        recognization.onstart = () => {
            setPlaceHolderVal(getTranslated(dict, "MSG_LISTEN"))
            setDisableMic(true)
        }
        recognization.onresult = (e) => {
            const transcript = e.results[0][0].transcript;
            setSearchValue(transcript)
            setPlaceHolderVal(getTranslated(dict, "MSG_BOT_HELP"))
            setDisableMic(false)
        }
        recognization.onend = (e) => {
            setDisableMic(false)
            setPlaceHolderVal(getTranslated(dict, "MSG_BOT_HELP"))
        }
        recognization.start();
    }

    const handleRating = (value) => {
        setRating(value)
    }

    const handleFeedback = (e) => {
        setFeedback(e.target?.value || "")
    }

    const handleSubmit = () => {
        submitFeedback(helpData.queryuuid, rating, feedback, () => {
            setFBSubmitted(true)
        })
    }

    return <div ref={observedDiv} className="header-item search-field">
        <div>
            {/* <span ref={observedDiv}> */}

            <Space.Compact
                style={{
                    width: '100%',
                }}
            >
                <Input
                    className="search-field"
                    value={searchValue}
                    onChange={handleChange}
                    onPressEnter={handleSend}
                    disabled={loading}
                    placeholder={placeHolderVal}
                    prefix={<img src={botIcon} alt="bot icon" height={18} />}
                    suffix={
                        searchValue ? <span onClick={() => handleSend()}>
                            {loading ? <LoadingOutlined /> : <SendOutlined style={{ cursor: "pointer", color: PURPLE }} />}
                        </span> : !isFirefox ? <Button
                            className="bot-mic"
                            onClick={() => runSpeechRecog()}
                            icon={<AudioFilled style={{ color: PURPLE }} title={getTranslated(dict, "LABEL_VOICE_SEARCH")}/>}
                            disabled={disableMic}
                        /> : <></>
                    }
                    style={{ marginLeft: 0 }}
                />
            </Space.Compact>

            <div className="bot-content" style={{ width: `${61.5}%`, display: helpData ? "block" : "none" }}>
                <div className="chat-close-btn">
                    <Button
                        shape="square"
                        icon={<CloseOutlined />}
                        onClick={() => handleChatClose()}
                    />
                </div>
                <div className="content-wrap">
                    <div className="content">
                        <img src={botIcon} alt="bot icon" className="chat-bot-icon" />
                        <Typography.Paragraph
                            className="arrow-box"
                            ellipsis={{
                                rows: 2,
                                expandable: 'collapsible',
                                expanded,
                                onExpand: (_, info) => {
                                    setExpanded(info.expanded)
                                },
                                symbol: expanded ? getTranslated(dict, "LABEL_LESS") : getTranslated(dict, "LABEL_MORE")
                            }}
                        >
                            {helpData?.content}
                        </Typography.Paragraph>
                    </div>
                    <div className="content">
                        <img src={botIcon} alt="bot icon" className="chat-bot-icon" />
                        <div className="arrow-box">
                            {helpData?.documents?.length ? <div>{formatDictString(dict, "MSG_DOC_FOUND", { n: helpData.documents.length })}</div> : <></>}
                            {helpData?.documents?.map((document) => {
                                return <SearchDocView document={document} />
                            })}
                        </div>
                    </div>
                    {(helpData?.content && !fbSubmitted) ? <div className="content">
                        <img src={botIcon} alt="bot icon" className="chat-bot-icon" />
                        <div className="arrow-box">
                            <div>{getTranslated(dict, "MSG_SATISFIED")}</div>
                            <div className="feedback-blk">
                                <Rate value={rating} onChange={handleRating} className="review-rate" />
                                {rating ? <>
                                    <TextArea showCount maxLength={100} value={feedback} onChange={handleFeedback} placeholder={getTranslated(dict, "LABEL_FEEDBACK")} />
                                    <UMCButton className="submit-btn" onClick={handleSubmit} label={getTranslated(dict, "LABEL_SUBMIT")} type="primary" size="small" />
                                </> : <></>}

                            </div>
                        </div>
                    </div> : <></>}
                </div>

            </div>
        </div>
    </div>
}

export default SearchBot